import type { TenantUser } from '@/types/user'

const BACKOFFICE_ROLES = new Set(['admin', 'manager'])

export function hasBackofficeAccess(user: TenantUser | null | undefined): boolean {
  if (!user?.roles?.length) return false
  return user.roles.some((r) => BACKOFFICE_ROLES.has(String(r).toLowerCase()))
}
